import {
  User,
  Landmark,
  Banknote,
  MapPin,
  Phone,
  Mail,
  Hash,
  Building,
  Map,
  Calendar,
  CreditCard,
} from "lucide-react";
import { type ReactElement } from "react";

import {
  type ClientType,
  type FieldTypes,
} from "../types/available-payment-methods";

// Map of property names to icons
const propertyIconMap: Record<FieldTypes, ReactElement> = {
  email: <Mail />,
  full_name: <User />,
  given_name: <User />,
  first_name: <User />,
  last_name: <User />,
  middle_name: <User />,
  family_name: <User />,
  name: <CreditCard />,
  phone: <Phone />,
  phone_number: <Phone />,
  address: <MapPin />,
  line_1: <MapPin />,
  city: <Building />,
  state: <MapPin />,
  zip: <Map />,
  routing: <Landmark />,
  account: <Landmark />,
  type: <Banknote />,
  card_number: <CreditCard />,
  expiration_date: <Calendar />,
  date_of_birth: <Calendar />,
  swift_code: <Landmark />,
  payer_name: <Landmark />,
  bank_name: <Landmark />,
  tax_number: <Hash />,
};

// Map of field types to icons (fallback)
const typeIconMap: Record<ClientType, ReactElement> = {
  email: <Mail />,
  numeric: <Hash />,
  phone: <Phone />,
  address: <MapPin />,
  ["month-year"]: <Calendar />,
  ["year-month"]: <Calendar />,
  iban: <Banknote />,
  date: <Calendar />,
  select: <MapPin />,
  bank_name: <Landmark />,
};

export const getFieldIcon = (
  propertyName: string,
  fieldType: ClientType
): ReactElement => {
  // First try to match by property name (case-insensitive)
  const normalizedPropertyName = propertyName.toLowerCase();
  const propertyIcon = Object.entries(propertyIconMap).find(([key]) =>
    normalizedPropertyName.includes(key.toLowerCase())
  )?.[1];

  if (propertyIcon) {
    return propertyIcon;
  }

  // Fallback to type-based icon
  return typeIconMap[fieldType] || null;
};
